import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../Layouts/Loader/Loader";
import { useAPIContext } from "../../context/APIContext";
import { useTreeContext } from "../../context/TreeDataContext";
import "./ApiPage.css";
import { getFolderFileById } from "../../utils/treeData/folderEditorUtils";
import HttpRequestTemplateApiSection from "./HttpTemplate/HttpRequestTemplateApiSection";
import WebhookApiSection from "./WebHook/WebhookApiSection";
import WebhookApiSectionLatest from "./WebHook/WebhookApiSectionLatest";
import ErrorMessage from "../../components/FormComponents/ErrorMessage";
import ActivityWebhookApiSection from "./ActivityWebhook/ActivityWebhookApiSection";
import PipelinesApiSection from "./Pipelines/PipelinesApiSection";

const ApiViewer = () => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { setSelectedApi, selectedApi } = useAPIContext();
  const { apiExplorerData } = useTreeContext();
  const { apiId } = useParams();

  useEffect(() => {
    if (!apiExplorerData || selectedApi?.id === apiId) return;
    const file = getFolderFileById(apiExplorerData, apiId);
    if (file) {
      setSelectedApi({
        id: file.id,
        name: file.name,
        parentData: file.parentData,
        fileInfo: file.fileInfo // required for webhook
      });
      setIsLoading(false);
    } else {
      navigate("../");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiId]);

  const renderApis = () => {
    switch (selectedApi.parentData) {
      case "http-request-templates":
        return <HttpRequestTemplateApiSection file={selectedApi} />;
      case "webhook":
        switch (selectedApi.fileInfo.version) {
          case "v2":
            return <WebhookApiSectionLatest file={selectedApi} />;
          default:
            return <WebhookApiSection file={selectedApi} />;
        }
      case "activity-webhook":
        return <ActivityWebhookApiSection file={selectedApi} />;
      case "pipelines":
        return <PipelinesApiSection file={selectedApi} />;
      default:
        return (
          <div className="d_flex justify_center align_center h_100">
            <ErrorMessage>Unsupported api template: {selectedApi.parentData}</ErrorMessage>
          </div>
        );
    }
  };

  return (
    <div className="w_100">
      {isLoading ? (
        <Loader />
      ) : (
        <div className="flex_column h_100">
          <div className="h_100">{renderApis()}</div>
        </div>
      )}
    </div>
  );
};

export default ApiViewer;
